import React, { useState } from 'react';
import Modal from './Modal';
import ContactForm from './ContactForm';
import './AboutPage.css';
import aboutImage from '../Assets/WEEM.png';
import gallery2 from '../Assets/2.jpeg';
import gallery3 from '../Assets/3.jpeg';
import gallery4 from '../Assets/4.jpeg';
import gallery5 from '../Assets/5.jpeg';
import gallery7 from '../Assets/7.jpeg';
import gallery8 from '../Assets/8.jpeg';

function AboutPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="about-page">
      <header className="about-header">
        <div className="header-content">
          <h1>Parity Empowerment Initiative (PEI)</h1>
          <p className="slogan">Every Change Matters</p>
          <p className="location">Uganda</p>
        </div>
      </header>

      <main className="about-content">
        <section className="mission-section">
          <div className="container">
            <div className="mission-content">
              <div className="mission-text">
                <h2>Our Mission</h2>
                <p>
                  To empower ALL women through economic sustainability, legal rights, and holistic support
                  systems that strengthen long-term resilience and financial independence.
                </p>
                <h2>Our Vision</h2>
                <p>
                  A Uganda where ALL women live with dignity, economic independence, and full participation in decision-making spaces.
                </p>
              </div>
              <div className="mission-image">
                <img 
                  src={aboutImage} 
                  alt="Parity Empowerment Initiative - Women Empowerment" 
                  className="about-page-image"
                  onError={(e) => {
                    console.error('Image failed to load:', e.target.src);
                  }}
                  onLoad={() => console.log('About page image loaded successfully')}
                />
              </div>
            </div>
          </div>
        </section>
        
        

        <section className="purpose-section">
          <div className="container">
            <h2>Our Impact (Emerging & Ongoing)</h2>
            <p>
              PEI seeks to empower diverse women in Uganda by removing economic barriers, supporting women-led grassroots organizations, fostering sustainable businesses, and promoting financial independence, creating an inclusive environment for all women to thrive.
            </p>
            <ul className="impact-list">
              <li>Increased economic independence and financial stability for women facing systemic exclusion</li>
              <li>Job creation within underserved communities</li>
              <li>Strengthened women-led enterprises and grassroots organizations beyond donor dependency</li>
              <li>Broader social and policy impact driven by economically empowered women</li>
            </ul>
          </div>
        </section>

        <section className="values-section">
          <div className="container">
            <h2>Our Core Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3>Feminist Leadership</h3>
                <p>Centering women's lived realities, autonomy, and agency.</p>
              </div>
              <div className="value-card">
                <h3>Inclusion</h3>
                <p>Ensuring accessibility and meaningful participation for women of all identities and abilities.</p>
              </div>
              <div className="value-card">
                <h3>Accountability</h3>
                <p>Practicing transparency and ethical stewardship of resources and partnerships.</p>
              </div>
              <div className="value-card">
                <h3>Community-Led Action</h3>
                <p>Designing solutions shaped by women's voices, knowledge, and priorities.</p>
              </div>
              <div className="value-card">
                <h3>Sustainability</h3>
                <p>Building systems that reduce dependency and support long-term resilience.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="gallery-section">
          <div className="container">
            <h2>Our Impact Gallery</h2>
            <div className="gallery-grid">
              <div className="gallery-item">
                <img src={gallery2} alt="Community empowerment" />
              </div>
              <div className="gallery-item">
                <img src={gallery3} alt="Women initiative" />
              </div>
              <div className="gallery-item">
                <img src={gallery4} alt="Local gathering" />
              </div>
              <div className="gallery-item">
                <img src={gallery5} alt="Parity initiative" />
              </div>
              <div className="gallery-item">
                <img src={gallery7} alt="Working together" />
              </div>
              <div className="gallery-item">
                <img src={gallery8} alt="Community support" />
              </div>
            </div>
          </div>
        </section>

        <section className="impact-section">
          <div className="container">
            <h2>Our Impact</h2>
            <div className="impact-stats">
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">Women-led organizations supported</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">200+</span>
                <span className="stat-label">Jobs created</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">10+</span>
                <span className="stat-label">Communities reached</span>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="about-footer">
        <div className="container">
          <p>Join us in creating lasting change for women in Uganda</p>
          <button 
            className="cta-button"
            onClick={() => setIsModalOpen(true)}
          >
            Get Involved
          </button>
        </div>
      </footer>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ContactForm 
          onClose={() => setIsModalOpen(false)} 
          formType="Get Involved Inquiry"
        />
      </Modal>
    </div>
  );
}

export default AboutPage;